export default __webpack_public_path__ + "static/media/steam_store.a04286e7.jpeg";